import React from 'react';
import { withStyles } from '@mui/styles';
import { subDays, startOfDay, endOfDay, format, parse, differenceInDays, isAfter } from 'date-fns';
import { connect } from 'react-redux';
import { axiosInstance } from 'utils';
import {
  Card,
  CardContent,
  Grid,
  Divider,
  Typography,
  Stack,   
  IconButton
} from '@mui/material';
import fileDownload from 'js-file-download';
import {
  CsvUtil,
  SpecialtyUtil
} from 'doctivity-shared/utils';
import { GetApp } from '@mui/icons-material';
import {
  ProviderCommentsReportTable,
  ProviderCommentsReportChart,
  ProviderCommentsTaggedByUserChart,  
  ProviderCommentsPerDayChart,
  ProviderCommentsTaggedPerDayChart,
  ProviderCommentsByLabel,
  ProviderCommentsOptions,
  ProviderCommentsHeadlines,
  ProviderCommentsAffiliationChart,
  ProviderCommentsSpecialtiesChart,
  ProviderCommentsCountiesChart
} from 'components';
import { PropTypes } from 'prop-types';

import { withIsMobile} from 'utils';

const styles = (theme) => ({
  container: {
    '& > *': {
      marginBottom: theme.spacing(4),
    },
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  card: {
    marginBottom: theme.spacing(3),
  },
  downloadTipIcon: {
    position: 'relative',
    top: -4,
    marginLeft: theme.spacing(),
    fontSize: 20,
    fontWeight: 100,
    color: '#999999',
  },
  downloadTipIconInvisible: {
    position: 'relative',
    top: -4,
    marginLeft: theme.spacing(),
    fontSize: 20,
    fontWeight: 100,
    color: 'transparent',
  },
  

  
});
const isValidDate = (d) => d instanceof Date && !isNaN(d);
const minimumStartDate = new Date(2018, 0, 1);
const DATE_PARSE_REF = new Date(2000, 0, 1);
class ProviderCommentsReportPage extends React.Component {
  constructor(props) {
    super(props);
    const startDate = new Date(
      sessionStorage.getItem('startDate') ?? undefined,
    );
    const endDate = new Date(sessionStorage.getItem('endDate') ?? undefined);
    const encounterType = sessionStorage.getItem('encounterType');
    const filterUser = sessionStorage.getItem('filterUser');
    this.state = {
      startDate: startOfDay(
        isValidDate(startDate) ? startDate : subDays(new Date(), 30),
      ),
      endDate: endOfDay(isValidDate(endDate) ? endDate : new Date()),
      
      encounterType: (encounterType && encounterType!='All') ? encounterType*1 : 'All',
      filterUser: filterUser ? JSON.parse(filterUser) : 'All Users',
      isTable: false,
    };
  }
 
  fetchSpecialtiesDownload() {
    const { encounterType, startDate, endDate, filterUser } = this.state;
    const { clientId } = this.props;

    let filter = {
      client_id: clientId,
      encounter_type_id: encounterType,
      user_id: filterUser?.id,
      comment_date: {
        $gte: startDate.toISOString(),
        $lte: endDate.toISOString(),
      },
    }
    
    if (encounterType !== 'All') {
      filter.encounter_type_id = encounterType;
    }

    axiosInstance
      .post('/Analytics', {
        type: 'PROVIDERS_SPECIALTY_COUNT',
        filter: filter,
        opts: {
          limit: 10000,
          offset: 0,
          //order: query.order,
        },

      },
      {
        params: {
          selected_client_id: clientId,
        }
      })
      .then((response) => {
        const filename = `doctivity_specialty_report_${format(new Date(), 'yy_MM_dd')}.csv`;
        try {
          const data = this.formatSpecialityDownload(response.data);
          fileDownload(data, filename);
        } catch (err) {
          console.error(`Could not format csv for ${filename}`);
          console.error(err);
          fileDownload(response.data, filename);
        }
      });
  }

  formatSpecialityDownload(data) {
    //let csvColumns = CsvUtil.stringToMatrix(data);

    let output = [];

     output.push(['count','code','specialty']);
    
    data.map((obj) => {
      let specialty = SpecialtyUtil.getNameFromTaxonomy(obj)
      output.push([obj.totalproviders, obj.code, specialty ? '"' + specialty + '"' : 'none']);
    })

    output = CsvUtil.matrixToString(output);
    

    return output;
  }

  fetchCountiesDownload() {
    const { encounterType, startDate, endDate, filterUser } = this.state;
    const { clientId } = this.props;

    let filter = {
      client_id: clientId,
      encounter_type_id: encounterType,
      user_id: filterUser?.id,
      comment_date: {
        $gte: startDate.toISOString(),
        $lte: endDate.toISOString(),
      },
    }
    
    if (encounterType !== 'All') {
      filter.encounter_type_id = encounterType;
    }

    axiosInstance
      .post('/Analytics', {
        type: 'PROVIDERS_COUNTY_COUNT',
        filter: filter,
        opts: {
          limit: 10000,
          offset: 0,
          //order: query.order,
        },

      },
      {
        params: {
          selected_client_id: clientId,
        }
      })
      .then((response) => {
        const filename = `doctivity_county_report_${format(new Date(), 'yy_MM_dd')}.csv`;
        try {
          const data = this.formatCountyDownload(response.data);
          fileDownload(data, filename);
        } catch (err) {
          console.error(`Could not format csv for ${filename}`);
          console.error(err);
          fileDownload(response.data, filename);
        }
      });
  }

  formatCountyDownload(data) {

    let output = [];

     output.push(['count','county']);
    
    data.map((obj) => {
      output.push([obj.totalproviders, '"' + obj.county_name + '"']);
    })

    output = CsvUtil.matrixToString(output);
    

    return output;
  }

  fetchAffiliatedDownload() {
    const { encounterType, startDate, endDate, filterUser } = this.state;
    const { clientId } = this.props;

    let filter = {
      client_id: clientId,
      encounter_type_id: encounterType,
      user_id: filterUser?.id,
      comment_date: {
        $gte: startDate.toISOString(),
        $lte: endDate.toISOString(),
      },
    }
    
    if (encounterType !== 'All') {
      filter.encounter_type_id = encounterType;
    }

    axiosInstance
      .post('/Analytics', {
        type: 'PROVIDERS_AFFILIATION_COUNT',
        filter: filter,
        opts: {
          limit: 10000,
          offset: 0,
          //order: query.order,
        },

      },
      {
        params: {
          selected_client_id: clientId,
        }
      })
      .then((response) => {
        const filename = `doctivity_affiliated_report_${format(new Date(), 'yy_MM_dd')}.csv`;
        try {
          const data = this.formatAffiliatedDownload(response.data);
          fileDownload(data, filename);
        } catch (err) {
          console.error(`Could not format csv for ${filename}`);
          console.error(err);
          fileDownload(response.data, filename);
        }
      });
  }

  formatAffiliatedDownload(data) {

    let output = [];

     output.push(['affiliated','unaffiliated']);
    
     output.push([data[0], data[1]]);

    output = CsvUtil.matrixToString(output);
    

    return output;
  }

  render() {
    const { classes, isMobile } = this.props;
    const { encounterType, filterUser, isTable } = this.state;
    const dateRange = {
      startDate: this.state.startDate,
      endDate: this.state.endDate
    };

    const sdatetimedisplay = format(new Date(this.state.startDate), 'M/d/yy');
    const edatetimedisplay = format(new Date(this.state.endDate), 'M/d/yy ');

    const sdatetime = format(new Date(this.state.startDate), 'yyyy-MM-dd  HH:mm:ss.000');
    const edatetime = format(new Date(this.state.endDate), 'yyyy-MM-dd  HH:mm:ss.000');

    const { showAffiliatedDownload, showCountiesDownload, showSpecialtiesDownload } = this.state; 

    var diffDays = differenceInDays(parse(edatetime, 'yyyy-MM-dd  HH:mm:ss.000', DATE_PARSE_REF), parse(sdatetime, 'yyyy-MM-dd  HH:mm:ss.000', DATE_PARSE_REF)) + 1;

    
    return (

          <div className={classes.container}>
            <ProviderCommentsOptions 
              dateRange={dateRange} 
              encounterType={encounterType}
              onChangeStartDate={this.onChangeStartDate}
              onChangeEndDate={this.onChangeEndDate}
              onChangeEncounterType={this.onChangeEncounterType}
              onChangeUser={this.onChangeUser}
              filterUser={filterUser}
            />

              <Card sx={{marginTop:3}}>
                <CardContent>
              { isTable && (
                <ProviderCommentsReportTable 
                  dateRange={dateRange} 
                  encounterType={encounterType}
                  filterUser={filterUser}
                  showChart={this.showChart}
                />
              )}
              { !isTable && (
                <ProviderCommentsReportChart
                dateRange={dateRange} 
                encounterType={encounterType}
                filterUser={filterUser}
                showTable={this.showTable}
                />
              )}
                </CardContent>
              </Card>


              <Card>
                <CardContent>
                  <div className={classes.header}>
                    <Typography component='h2' variant='h6' color='primary'>
                      Outreach Trends
                    </Typography>
                    <Typography fontWeight='300' color='black'>
                      {sdatetimedisplay} to {edatetimedisplay} | Trend versus previous {diffDays} days
                    </Typography>
                  </div>

                  <ProviderCommentsHeadlines 
                      dateRange={dateRange} 
                      encounterType={encounterType}
                      filterUser={filterUser}
                  />

                <Divider />
              { !isMobile && (
                <Grid container marginTop='50px' spacing={1} columns={{ xs: 1, md: 1, lg: 12, xl: 12 }}>
                  <Grid marginBottom='50px' size={{ xs: 1, md: 1, lg: 4, xl: 4 }} justifyContent='center' alignItems='center'>
                    <Stack direction='row' spacing={2} justifyContent='left' alignItems='center'
                      onMouseEnter={() => this.showDownload('specialties',true)}
                      onMouseLeave={() => this.showDownload('specialties',false)}>
                      <Typography fontWeight='normal' color='black'  style={{ width: '100%', textAlign: 'center'}}>
                        Specialties of Tagged Providers
                      </Typography>
                      <div>
                      { showSpecialtiesDownload && (
                            <IconButton 
                            onClick={() => {
                              this.fetchSpecialtiesDownload();
                            } }
                            size='small'
                          >
                          <GetApp className={classes.downloadTipIcon} />
                          </IconButton>
                      )}
                      { !showSpecialtiesDownload && (
                            <IconButton                   
                            size='small'
                          >
                          <GetApp className={classes.downloadTipIconInvisible} />
                          </IconButton>
                      )}
                        
                      </div>
                    </Stack>
                    <ProviderCommentsSpecialtiesChart 
                      dateRange={dateRange} 
                      encounterType={encounterType}
                      filterUser={filterUser}
                    />

                  </Grid>

                  <Grid size={{ xs: 1, md: 1, lg: 4, xl: 4 }} justifyContent='center' alignItems='center'>
                  <Stack direction='row' spacing={2} justifyContent='left' alignItems='center'
                    onMouseEnter={() => this.showDownload('affiliated',true)}
                    onMouseLeave={() => this.showDownload('affiliated',false)}>
                    <Typography fontWeight='normal' color='black'  style={{ width: '100%', textAlign: 'center'}}>
                        Affiliation of Tagged Providers
                      </Typography>
                      <div>
                      { showAffiliatedDownload && (
                            <IconButton 
                            onClick={() => {
                              this.fetchAffiliatedDownload();
                            } }
                            size='small'
                          >
                          <GetApp className={classes.downloadTipIcon} />
                          </IconButton>
                      )}
                      { !showAffiliatedDownload && (
                            <IconButton                   
                            size='small'
                          >
                          <GetApp className={classes.downloadTipIconInvisible} />
                          </IconButton>
                      )}
                        
                      </div>
                    </Stack>
                    <ProviderCommentsAffiliationChart 
                      dateRange={dateRange} 
                      encounterType={encounterType}
                      filterUser={filterUser}
                    />

                    
                          
                  </Grid>
                  <Grid marginBottom='50px' size={{ xs: 1, md: 1, lg: 4, xl: 4 }} justifyContent='center' alignItems='center'
                    onMouseEnter={() => this.showDownload('counties',true)}
                    onMouseLeave={() => this.showDownload('counties',false)}
                    >
                    
                    <Stack direction='row' spacing={2} justifyContent='left' alignItems='center'>
                      <Typography fontWeight='normal' color='black'  style={{ width: '100%', textAlign: 'center'}}>
                        Counties of Tagged Providers
                      </Typography>   
                      
                      <div>
                      { showCountiesDownload && (
                            <IconButton 
                            onClick={() => {
                              this.fetchCountiesDownload();
                            } }
                            size='small'
                          >
                          <GetApp className={classes.downloadTipIcon} />
                          </IconButton>
                      )}
                      { !showCountiesDownload && (
                            <IconButton                   
                            size='small'
                          >
                          <GetApp className={classes.downloadTipIconInvisible} />
                          </IconButton>
                      )}
                        
                      </div>
                    </Stack>
                    <ProviderCommentsCountiesChart 
                        dateRange={dateRange} 
                        encounterType={encounterType}
                        filterUser={filterUser}
                      />                

                  </Grid>
                </Grid>
              )}
              </CardContent>
            </Card>

            { !isMobile && (
            <Card sx={{marginTop:3}}>
                <CardContent>
                  <ProviderCommentsTaggedByUserChart
                    dateRange={dateRange} 
                    encounterType={encounterType}
                    filterUser={filterUser}
                  />
                </CardContent>
              </Card>
            )}

            { !isMobile && (
            <ProviderCommentsPerDayChart 
              dateRange={dateRange}
              encounterType={encounterType}
              filterUser={filterUser}
            />
            )}
            { !isMobile && (
            <ProviderCommentsTaggedPerDayChart 
              dateRange={dateRange} 
              filterUser={filterUser}
              encounterType={encounterType}
            />

            )}
            { !isMobile && (
            <ProviderCommentsByLabel

              dateRange={dateRange} 
              filterUser={filterUser}
              encounterType={encounterType}
            />
            )}

            { isMobile && (
            <Typography className={classes.centerLabel}>
              Please visit this page on desktop to see all charts.
            </Typography>
            )}

          </div>
    );
  }

  showTable = () => {
    this.setState({isTable: true});
  }

  showChart = () => {
    this.setState({isTable: false});
    this.setState({isData: true});      

  }

  onChangeUser = (newUser) => {
    sessionStorage.setItem('filterUser', JSON.stringify(newUser));
    this.setState(
        { filterUser: newUser !== 'All Users' ? newUser : 'All Users' }
    );
  };

  onChangeEncounterType = (type) => {
    sessionStorage.setItem('encounterType', type);
    this.setState({
      encounterType: type
    });
  }


  onChangeStartDate = (newDate) => {
    if (isAfter(newDate, minimumStartDate)) {
      sessionStorage.setItem('startDate', newDate);
      this.setState({
        startDate: startOfDay(newDate)
      });
    }
  }

  onChangeEndDate = (newDate) => {
    sessionStorage.setItem('endDate', newDate);
    this.setState({
      endDate: endOfDay(newDate)
    });
  }

  showDownload(val,showIt) {

    if (val==='affiliated') {
      this.setState({
        'showAffiliatedDownload': showIt
      }); 
    } else if (val==='counties') {
      this.setState({
        'showCountiesDownload': showIt
      }); 
    } else if (val==='specialties') {
      this.setState({
        'showSpecialtiesDownload': showIt
      }); 
    }
} 

  

}

ProviderCommentsReportPage.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  clientId: PropTypes.number.isRequired,

};

function mapStateToProps(state) {
  const { app, user } = state;

  return {
    user,
    clientId: app.selectedClient,
  };
}
const styled = withIsMobile(withStyles(styles)(ProviderCommentsReportPage));
const connected = connect(mapStateToProps)(styled);
export { connected as ProviderCommentsReportPage };
